'use client';

import { useAuth, useGetWatchlist } from '@morfi/backend-sdk-v2/client';

type WatchlistArgs = Parameters<typeof useGetWatchlist>[0];
type WatchlistOptions = Parameters<typeof useGetWatchlist>[1];

export function useAuthenticatedWatchlist(
  args: WatchlistArgs,
  options?: WatchlistOptions,
): ReturnType<typeof useGetWatchlist> {
  const { isAuthenticated } = useAuth();

  return useGetWatchlist(
    {
      ...args,
      fields: ['pubkeys'],
    },
    {
      ...options,
      enabled: isAuthenticated && options?.enabled !== false,
    },
  );
}
